import { FC, ReactNode } from 'react';
import style from './index.module.css';
import { HorizontalRule } from '../HorizontalRule';

export const InformationBox: FC<{ 
  title: string,
  children: ReactNode,
}> = ({
  title,
  children
}) => {

  return (
    <div className={style.informationBox}>
      <h4 className={style.informationBox_title}>{title}</h4>
      <HorizontalRule size={'small'}/>
      {children}
    </div>
  )
}